module.exports = __webpack_public_path__ + "static/media/zola-logo-horizontal-black.34453bcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-logo-horizontal-black.svg
// module id = 1497
// module chunks = 44